type RuntimeConfigKey =
  | 'VITE_API_BASE_URL'
  | 'VITE_OIDC_AUTHORITY'
  | 'VITE_OIDC_AUDIENCE'
  | 'VITE_OIDC_CLIENT_ID'
  | 'VITE_OIDC_REDIRECT_URI'
  | 'VITE_OIDC_POST_LOGOUT_REDIRECT_URI'
  | 'VITE_OIDC_SCOPE'
  | 'VITE_APP_VERSION';

type RuntimeConfig = Partial<Record<RuntimeConfigKey, string>>;

type RuntimeConfigWindow = Window & { __APP_CONFIG__?: RuntimeConfig };

function readWindowConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return (window as RuntimeConfigWindow).__APP_CONFIG__ ?? {};
}

export function readRuntimeConfig(key: RuntimeConfigKey, fallback = ''): string {
  const fromWindow = readWindowConfig()[key];

  if (typeof fromWindow === 'string' && fromWindow.length > 0) {
    return fromWindow;
  }

  return fallback;
}
